import { createFileRoute, Outlet } from "@tanstack/solid-router";

export const Route = createFileRoute("/_dashboard/dashboard/accounts")({
  staticData: {
    breadcrumb: "Accounts",
  },
  component: () => <Outlet />,
});
